import { LocationPromise } from "../types/location";

import { newId } from "./uid";

const appendToHead = <T extends Node>(asset: T) =>
  document.head && document.head.appendChild(asset);

export const loadAsset = ({ url }: { url: string }) =>
  new Promise<void>((resolve, reject) => {
    const asset = createScript({
      onError: error => reject(error),
      onLoad: () => resolve(),
      url
    });
    appendToHead(asset);
  });

const createScript = ({
  onError,
  onLoad,
  url
}: {
  url;
  onLoad?;
  onError;
}): HTMLElement => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  if (onLoad) {
    script.addEventListener("load", onLoad, false);
  }
  if (onError) {
    script.addEventListener("error", onError, false);
  }
  return script;
};

const promiseWithTimeout = (promise, timeoutMs) => {
  const timeoutPromise = new Promise((_, reject) => {
    const id = setTimeout(() => {
      clearTimeout(id);
      reject("Request timed out in " + timeoutMs + "ms");
    }, timeoutMs);
  });

  return Promise.race([promise, timeoutPromise]);
};

export const getJsonP = (url, key): LocationPromise => {
  const requestPromise = new Promise((resolve, reject) => {
    const callbackName = newId(key);
    const urlWithQueryAndKeys = `${url}?callback=${callbackName}&${__API_KEYS}`;
    const script = createScript({
      onError: () => reject(`${url}: script loading error`),
      url: urlWithQueryAndKeys
    });
    window[callbackName] = json => {
      resolve(json);
      // eslint-disable-next-line no-unused-expressions
      document.head && document.head.removeChild(script);
      delete window[callbackName];
    };

    appendToHead(script);
  });

  return promiseWithTimeout(requestPromise, 3000);
};
